import { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';

const POLL_INTERVAL = 30_000;

export type NotifLead = {
    _id: string;
    createdAt: string;
    offerBuyerNumber?: number | string;
    offerId?: string;
    approvalStatus?: string;
    customerRate?: number;
    leadrsRate?: number;
    buyerSeen?: boolean;
};

export function useLeadNotifications() {
    const [leads, setLeads] = useState<NotifLead[]>([]);
    const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

    const fetchLeads = useCallback(async () => {
        const token = localStorage.getItem('token');
        if (!token || token.length < 10) return;
        try {
            const res = await axios.get(`${CONFIG.apiUrl}/lead`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setLeads(res.data || []);
        } catch {
            // silently ignore — user may not be logged in yet
        }
    }, []);

    useEffect(() => {
        fetchLeads();
        intervalRef.current = setInterval(fetchLeads, POLL_INTERVAL);
        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [fetchLeads]);

    const newLeads = leads.filter((l) => !l.buyerSeen);

    const markAsSeen = useCallback(async () => {
        const token = localStorage.getItem('token');
        if (!token) return;
        try {
            await axios.put(
                `${CONFIG.apiUrl}/lead/mark-seen`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setLeads((prev) => prev.map((l) => ({ ...l, buyerSeen: true })));
        } catch {
            // ignore
        }
    }, []);

    return { newLeads, unreadCount: newLeads.length, markAsSeen };
}
